export const manifest = {
  screens: {

  },
  deletedScreens: {
    scr_nzp8l4: { name: "Waitlist Success", route: "/waitlist", state: {"submitted":true}, position: {"x":1560,"y":220}, deletedAt: "2026-06-22T20:27:27.843Z" },
    scr_7o8gty: { name: "Waitlist Form", route: "/waitlist", state: {"submitted":false}, position: {"x":160,"y":220}, deletedAt: "2026-06-22T20:27:29.303Z" },
  },
  layers: [],
}
